// src/Components/JobManagement.js
import React, { useState } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Divider,
} from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: { main: "#1F2661" },
    background: { default: "#f4f6fb" },
    text: { primary: "#2d2d2d", secondary: "#555" },
  },
  typography: { fontFamily: "Segoe UI, sans-serif" },
});

function JobManagement({ jobs, setShowForm, setSelectedPosition }) {
  const [selectedJob, setSelectedJob] = useState(null);

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ minHeight: "fit-content", bgcolor: "background.default", display: "flex", flexDirection: "column", alignItems: "center", py: 4, px: 2, }} >
        <Typography variant="h5" sx={{ mb: 4, fontWeight: 600, color: "#1F2661" }}> Available Job Openings </Typography>
        <Grid container spacing={3} justifyContent="center" maxWidth="lg">
          {jobs && jobs.length > 0 ? (
            jobs.map((job) => (
              <Grid item key={job._id}>
                <Card
                  onClick={() => setSelectedJob(job)}
                  sx={{
                    borderRadius: 3,
                    p: 2,
                    height: 250,
                    width: 300,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    cursor: "pointer",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                    transition: "all 0.3s ease",
                    background: "#fff",
                    "&:hover": {
                      transform: "scale(1.03)",
                      boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
                    },
                  }}
                >
                  <CardContent>
                    <Typography variant="h6" sx={{ fontWeight: 600, mb: 1, color: "#1F2661" }}>
                      {job.title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {job.company}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      {job.location}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))
          ) : (
            <Typography color="text.secondary">No jobs available</Typography>
          )}
        </Grid>

        {/* Popup */}
        <Dialog open={Boolean(selectedJob)} onClose={() => setSelectedJob(null)} maxWidth="md" fullWidth>
          {selectedJob && (
            <>
              <DialogTitle sx={{ fontWeight: 600, color: "#1F2661" }}>
                {selectedJob.title}
              </DialogTitle>
              <Divider />
              <DialogContent dividers>
                <Typography variant="subtitle1" sx={{ mb: 2 }}>
                  {selectedJob.company} – {selectedJob.location}
                </Typography>

                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Typography><strong>Type:</strong> {selectedJob.type}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography><strong>Employment:</strong> {selectedJob.employmentType}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography><strong>Mode:</strong> {selectedJob.workMode}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography><strong>Experience:</strong> {selectedJob.experience}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography><strong>Salary:</strong> {selectedJob.salary}</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography><strong>Skills:</strong> {selectedJob.skills.join(", ")}</Typography>
                  </Grid>
                </Grid>

                <Typography sx={{ mt: 2 }}>
                  <strong>Description:</strong> {selectedJob.description}
                </Typography>
                <Typography><strong>Perks:</strong> {selectedJob.perks}</Typography>

                <Typography sx={{ mt: 2 }}>
                  <strong>Application Link:</strong>{" "}
                  <a href={selectedJob.applicationLink} target="_blank" rel="noreferrer"
                     style={{ textDecoration: "underline", color: "#1F2661" }}>
                    {selectedJob.applicationLink}
                  </a>
                </Typography>
                <Typography sx={{ mt: 1 }}>
                  <strong>Deadline:</strong> {new Date(selectedJob.applicationDeadline).toDateString()}
                </Typography>
              </DialogContent>

              <DialogActions>
                <Button variant="contained" color="inherit" onClick={() => setSelectedJob(null)}>
                  Close
                </Button>
                <Button
                  variant="contained"
                  sx={{ bgcolor: "#1F2661", color: "white", "&:hover": { bgcolor: "#3b3f7f" } }}
                  onClick={() => {
                    if (window.location.pathname === "/sts_client/career") {
                      // ✅ Save position automatically
                      setSelectedPosition(selectedJob.title);
                      setSelectedJob(null);
                      setShowForm(true);
                    } else if (window.location.pathname === "/sts_client/consultancy") {
                      window.open(selectedJob.applicationLink, "_blank");
                    }
                  }}
                >
                  Apply Now
                </Button>
              </DialogActions>
            </>
          )}
        </Dialog>
      </Box>
    </ThemeProvider>
  );
}

export default JobManagement;
